/* eslint-disable import/prefer-default-export */
import classify from '../../helpers/classify';
import getOptions from './getOptions';

export const ID = 'cms-hero-video';
export const ICON = `${ID}__icon`;
export const VIDEO = `${ID}__video`;
export const CONTROLS = `${ID}__controls`;
export const PLAYPAUSE = `${ID}__playpause`;
export const IS_PLAYING = 'isPlaying';
export const OPTIONS = 'video-options';

const initPlayer = (videoContainer: HTMLDivElement): void => {
  const options = getOptions(videoContainer, OPTIONS);
  const supportsVideo = !!document.createElement('video').canPlayType;

  if (supportsVideo) {
    const video = videoContainer.querySelector(classify(VIDEO)) as HTMLVideoElement;

    if (options.controls && video) {
      const controls = videoContainer.querySelector(classify(CONTROLS));
      const playpause = controls?.querySelector(classify(PLAYPAUSE));

      playpause?.addEventListener('click', () => {
        if (video.paused || video.ended) video.play();
        else video.pause();
      });

      video.addEventListener(
        'play',
        () => {
          videoContainer.classList.add(IS_PLAYING);
          video.controls = true;
        },
        false
      );

      video.addEventListener(
        'pause',
        () => {
          videoContainer.classList.remove(IS_PLAYING);
          video.controls = false;
        },
        false
      );
    }
  }
};

const findAllHeroVideoPlayers = (): NodeListOf<HTMLDivElement> =>
  document.querySelectorAll<HTMLDivElement>(classify(ID));

export function initAllHeroPlayers(): void {
  const allPlayers = findAllHeroVideoPlayers();
  allPlayers.forEach((p) => {
    initPlayer(p);
  });
}
